import { useContract } from '@thirdweb-dev/react-core';

import yieldBooster from '../../../abis/YieldBooster.json';
import xKimToken from '../../../abis/XKimToken.json';

import { SmartContract, useAddress } from '@thirdweb-dev/react';
import { ethers } from 'ethers';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { Address } from '@thirdweb-dev/sdk';
import { useConfig } from '@app/config';
import { ApplicationConfig } from '@app/config/types';

async function fetcher(
  contract: SmartContract<ethers.BaseContract> | undefined,
  xKimContract: SmartContract<ethers.BaseContract> | undefined,
  address: Address | undefined,
  config: ApplicationConfig | undefined
) {
  if (!contract || !xKimContract || !address) {
    return;
  }

  const totalAllocation = await contract.call('totalAllocation');
  const yourAllocation = await contract.call('getUserTotalAllocation', [
    address
  ]);

  const deallocationFee = await xKimContract.call('usagesDeallocationFee', [
    config?.CONTRACTS.YIELD_BOOSTER
  ]);

  const xKimBalance = await xKimContract.call('balanceOf', [address]);

  return {
    totalAllocation: ethers.utils.formatUnits(totalAllocation, 18),
    yourAllocation: ethers.utils.formatUnits(yourAllocation, 18),
    deallocationFee: deallocationFee / 100,
    xKimBalance: ethers.utils.formatUnits(xKimBalance, 18)
  };
}

export function useBoosterStats() {
  const address = useAddress();
  const config = useConfig();

  const { contract } = useContract(
    config?.CONTRACTS.YIELD_BOOSTER,
    yieldBooster.abi
  );

  const { contract: xKimContract } = useContract(
    config?.CONTRACTS.X_KIM,
    xKimToken.abi
  );

  const { data, isLoading } = useQuery(
    [QueryKeys.BOOSTER_STATS, address],
    () => fetcher(contract, xKimContract, address, config),
    {
      enabled: !!(contract && xKimContract && address)
    }
  );

  return {
    data,
    isLoading
  };
}
